export const ADD_COURSES = "ADD_COURSES";
export const ADD_SESSIONS = "ADD_SESSIONS";
export const ADD_SEMESTERS = "ADD_SEMESTERS";
export const ADD_USER = "ADD_USER";
export const MSG_STATUS = "MSG_STATUS";
export const MSG_MESSAGE = "MSG_MESSAGE";
export const MSG_CLOSE = "MSG_CLOSE";
export const LEAVE_BALANCE = "LEAVE_BALANCE";
export const DEPT_SUBJECT = "DEPT_SUBJECT";
